var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCapitalGoodH(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#febe07",
    d: "M15 32h12c3 0 5-2 5-5v-3c0-5-4-12-5-12H15c-1 0-5 7-5 12v3c0 3 2 5 5 5zM29 4l-2 1h-1l-2-2h-1l-1 2h-2l-1-2h-1l-2 2h-4v1l3 6h12l3-7-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b18300",
    d: "M27 32c3 0 5-2 5-5v-3c0-5-4-12-5-12H15c-1 0 6 0 10 6 3 4 2 14 2 14zm2-28-2 1c-2 3-6 5-10 6h-2v1h12l3-7-1-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5aa2ff",
    d: "M35 4h10v28H35z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b67b3",
    d: "m45 16-4 4-4 4h2v8h6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5aa2ff",
    d: "M29 16h-3v16h9V16zm18 11h4v5h-4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe5cf",
    d: "m58 30-3 2-3 6-7 3c0-2-2-4-4-4H27c-6 0-11 2-16 5v15h24a26 26 0 0 0 25-21v-3c1-1-1-3-2-3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbe6fe",
    d: "M55 24H43v8h4v-5h4v5h4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b67b3",
    d: "M10 37H4l-1 1v22l1 1h6l1-1V38l-1-1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#b18300",
    d: "m57 24-8-8-4 4-4 4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b67b3",
    d: "M32 16h3v16h-3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4 62h6l2-2v-2h23a27 27 0 0 0 26-22v-3a4 4 0 0 0-5-4v-4h1a1 1 0 0 0 1-2l-8-8h-2l-2 3V4l-1-1H35l-1 1v11h-4l-2-3 3-6-1-2-2-1-2 1-1-1a2 2 0 0 0-2 0l-2 1-1-1a2 2 0 0 0-3 0l-1 1h-5v2l3 6c-2 2-5 7-5 12v3c0 3 3 6 6 6h38l-2 4-5 3c-1-2-3-4-5-4H27c-6 0-11 1-15 4v-2l-2-2H4l-2 2v22l2 2zM15 6h2l2-2 1 2a2 2 0 0 0 2 0l2-2 1 2h2l2-1-3 6h-2l1-3h-2l-2 3h-1l-2-3-2 1 1 2h-1l-3-5zm10 10v15H15c-2 0-4-2-4-4v-3c0-5 3-10 4-11h12l1 2h-2l-1 1zm2 1h7v14h-7zm22 0 6 6H43zM36 5h8v15l-4 3a1 1 0 0 0 1 2h1v6h-6zm8 20h10v6h-2v-4l-1-1h-4l-1 1v4h-2zm6 6h-2v-3h2zm-23 7h14a3 3 0 0 1 0 6H25v2h16c3 0 5-2 5-4l6-3 1-1 3-6a2 2 0 0 1 3 0v4a25 25 0 0 1-24 20H12V43c4-3 9-5 15-5zM4 38h6v22H4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6 41h2v3H6zM38 7h1v2h-1zm3 0h1v2h-1zm-3 4h1v2h-1zm3 0h1v2h-1zm-3 4h1v2h-1zm3 0h1v2h-1zm-12 4h1v2h-1zm3 0h1v2h-1zm-3 4h1v2h-1zm3 0h1v2h-1zm-3 4h1v2h-1zm3 0h1v2h-1zm6-8h1v2h-1zm3 0h1v2h-1zm-19-1h-1v-1h-2v1h-1l-1 1v3l1 1h3v1h-4v1l1 1h1v1h2v-1h1l1-1v-3l-1-1h-3v-1h4v-1l-1-1zM53 4h2v2h-2zm2-2h2v2h-2zm2 2h2v2h-2zm-2 2h2v2h-2zm5 3h2v2h-2zm-7 3h2v2h-2zM2 11h2v2H2zm2-2h2v2H4zm2 2h2v2H6zm-2 2h2v2H4zm-2 6h2v2H2zM6 2h2v2H6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapitalGoodH);
export default __webpack_public_path__ + "static/media/CapitalGood-h.10c4ee81c7194dcade5e58b9ab37bb5d.svg";
export { ForwardRef as ReactComponent };